import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const SnippetsList = styled.ul`
 display: flex;
 margin: 0;
 max-width: 31.25rem;
 padding: 0;
`;

const  SnippetItem = styled.li`
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  font-size: .875rem;
  font-style: italic;
  font-weight: 500;
  list-style-type: none;
  margin: 0 0 .5rem;
  padding: 0;

  :last-child {
    margin: 0;
  }
`;

function Snippets({ data, limit }) {
  const snippetArr = limit ? data.slice(0, limit) : data;
  return (
      <SnippetsList>
        {snippetArr.map((item) => {
          const {attributes} = item;
          const {title} = attributes;
          return (
            <SnippetItem key={title}>
              "{title}"
            </SnippetItem>
            );
        })}
      </SnippetsList>
  );
}

export default Snippets;

Snippets.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  limit: PropTypes.number,
};

Snippets.defaultProps = {
  data: [],
  limit: undefined,
};
